export default __webpack_public_path__ + "static/media/avatar_119.efdae887.png";